// import { mapGetters } from 'vuex'
import Dayjs from 'dayjs'
import AreaAnalysisChart from '@/views/Fdc/Report/FaultAnalysisReport/Components/AreaAnalysisChart'
import EqpModelAnalysisChart from '@/views/Fdc/Report/FaultAnalysisReport/Components/EqpModelAnalysisChart'
import EqpAnalysisChart from '@/views/Fdc/Report/FaultAnalysisReport/Components/EqpAnalysisChart'
import FdModelAnalysisChart from '@/views/Fdc/Report/FaultAnalysisReport/Components/FdModelAnalysisChart'

/**
 * Report > Fault Analysis Report
 * Fault Analysis Report (Area > EQP Model > EQP > Fault Detection Model)
 */
export default {
  name: 'FaultAnalysisReport',
  components: {
    'area-analysis-chart': AreaAnalysisChart, // Area Analysis Chart component
    'eqp-model-analysis-chart': EqpModelAnalysisChart, // EQP Model Analysis Chart component
    'eqp-analysis-chart': EqpAnalysisChart, // EQP Analysis Chart component
    'fd-model-analysis-chart': FdModelAnalysisChart // Fault Detection Model Analysis Chart component
  },
  mounted () {
  },
  props: {},
  watch: {
    /**
     * fromDate 변화 감지
     */
    fromDate () {
      this.toMinDate = this.fromDate
    },
    /**
     * toDate 변화 감지
     */
    toDate () {
      this.fromMaxDate = this.toDate
    }
  },
  methods: {
    /**
     * splitpanes resize 시 Plotly chart 리사이즈
     * 윈도우 resize 이벤트 생성해서 디스패치
     */
    splitPanesResized () {
      window.dispatchEvent(new Event('resize'))
    },
    /**
     * EQP Tree select시 수행하는 method
     * @param {Object} node 선택된 tree node data
     */
    eqpTreeSelected (node) {
      this.selectedTreeNode = node
    },
    /**
     * Fault Analysis Report 조회
     */
    searchFaultAnalyisReport () {
      if (this.selectedTreeNode.length === 0) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Item']))
        return
      }
      let node = this.selectedTreeNode
      this.searchTreeNode = this.selectedTreeNode

      this.$commonUtil.setStoreEqpTree(
        this.selectedTreeNode,
        this.$refs.fdcEqpTree.treeType
      )

      let param = {
        fab: node.detail.fab,
        area: node.detail.area,
        eqpModel: node.detail.eqpModel,
        fromDate: Dayjs(this.fromDate).format('YYYYMMDD') + '000000000',
        toDate: Dayjs(this.toDate).format('YYYYMMDD') + '235959999'
      }

      this.getAreaAnalysisChart(param)
    },
    /**
     * 조회 조건 설정 (Area Analysis)
     * @param {*} param 조회 조건
     */
    getAreaAnalysisChart (param) {
      this.searchCondition = param
    },
    /**
     * Area Analysis Chart select event
     * @param {Object} value 선택된 data
     */
    areaAnalysisChartSelected (value) {
      if (value !== null) {
        let obj = {
          fab: value.fab,
          area: value.area,
          eqpModel: value.eqpModel,
          fromDate: Dayjs(this.fromDate).format('YYYYMMDD') + '000000000',
          toDate: Dayjs(this.toDate).format('YYYYMMDD') + '235959999'
        }
        this.areaSelectedObj = obj
      } else {
        this.areaSelectedObj = value
      }
    },
    /**
     * EQP Model Analysis Chart select event
     * @param {Object} value 선택된 data
     */
    eqpModelAnalysisChartSelected (value) {
      if (value !== null) {
        let obj = {
          fab: value.fab,
          area: value.area,
          eqpModel: value.eqpModel,
          fromDate: Dayjs(this.fromDate).format('YYYYMMDD') + '000000000',
          toDate: Dayjs(this.toDate).format('YYYYMMDD') + '235959999'
        }
        this.eqpModelSelectedObj = obj
      } else {
        this.eqpModelSelectedObj = value
      }
    },
    /**
     * EQP Analysis Chart select event
     * @param {Object} value 선택된 data
     */
    eqpAnalysisChartSelected (value) {
      if (value !== null) {
        let obj = {
          fab: value.fab,
          area: value.area,
          eqpModel: value.eqpModel,
          eqpId: value.eqpId,
          fromDate: Dayjs(this.fromDate).format('YYYYMMDD') + '000000000',
          toDate: Dayjs(this.toDate).format('YYYYMMDD') + '235959999'
        }
        this.eqpSelectedObj = obj
      } else {
        this.eqpSelectedObj = value
      }
    },
    /**
     * Fault Detection Model Analysis Chart select event
     * @param {Object} value 선택된 data
     */
    fdModelAnalysisChartSelected (value) {
      // let obj = {
      //   fab: value.fab,
      //   area: value.area,
      //   eqpModel: value.eqpModel,
      //   eqpId: value.eqpId,
      //   fromDate: Dayjs(this.fromDate).format('YYYYMMDD') + '000000000',
      //   toDate: Dayjs(this.toDate).format('YYYYMMDD') + '235959999'
      // }
      // this.fdModeSelectedObj = obj
    }
  },
  data () {
    const dateString = new Date().toDateString()
    let fromDt = new Date(Dayjs(dateString).add(-1, 'day').format('YYYY.MM.DD'))
    let toDt = new Date()
    return {
      searchCondition: null, // 검색 조건 (Area Analysis)
      selectedTreeNode: [], // 선택된 EQP Tree node
      searchTreeNode: [], // 검색된 EQP Tree node
      fromDate: fromDt, // From Date value
      toDate: toDt, // To Date value
      fromMaxDate: toDt, // From Date Max value
      fromMinDate: null, // From Date Min value
      toMaxDate: toDt, // To Date Max value
      toMinDate: fromDt, // To Date Min value
      areaSelectedObj: null, // 선택된 Area Analysis Chart data
      eqpModelSelectedObj: null, // 선택된 EQP Model Analysis Chart data
      eqpSelectedObj: null // 선택된 EQP Analysis Chart data
    }
  }
}
